import { CampaignChecklistController } from './campaign-checklist.controller'

function campaignChecklist () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-checklist/campaign-checklist.html?$$REVISION$$',
    controller: CampaignChecklistController
  }
}

export { campaignChecklist }
